import { WorkflowEventTriggerType } from 'shared/types/graphql';
import { useAppSelector } from 'state/hooks';
import { getVisibleAutomationFields } from '../state/utils/getVisibleAutomationFields';
import { AutomationType } from '../types/AutomationDraft';

export const useGetFieldVisibility = (
  automationType?: AutomationType | null,
  triggerType?: WorkflowEventTriggerType,
): ReturnType<typeof getVisibleAutomationFields> => {
  const currentlySelectedAutomationType = useAppSelector((state) => state.automations.automationDraft.automationType);
  const currentlySelectedTriggerType = useAppSelector((state) => state.automations.automationDraft.triggerType);
  if (!automationType) {
    automationType = currentlySelectedAutomationType;
  }
  if (!triggerType) {
    triggerType = currentlySelectedTriggerType;
  }

  return getVisibleAutomationFields({ automationType, triggerType });
};
